import { withDefaults } from 'react-bem-helper';

export default withDefaults({
    outputIsString: true,
});
